import { Maybe } from 'types/graphqlTypes'
import { ONE_CENT } from '../constants'
import { TTierNumber } from '../types'

export interface IGetTierRangeProps {
  tierNumber: TTierNumber
  tier1Max?: number
  tier2Max?: number
  tier3Max?: number
}

export interface ITierRange {
  min: Maybe<number>
  max: Maybe<number>
}

/**
 * Returns the min and max values for a specific tier
 * @example getTierRange({ tierNumber: 2, tier1Max: 1100, tier2Max: 1250, tier3Max: 1350 }) // { min: 1101, max: 1250 }
 */
export const getTierRange = ({
  tier1Max = 0,
  tier2Max = 0,
  tier3Max = 0,
  tierNumber,
}: IGetTierRangeProps): Maybe<ITierRange> => {
  if (tierNumber === 4) {
    return {
      min: tier3Max + ONE_CENT,
      max: null,
    }
  }

  if (tierNumber === 3) {
    return {
      min: tier2Max + ONE_CENT,
      max: tier3Max,
    }
  }

  if (tierNumber === 2) {
    return {
      min: tier1Max + ONE_CENT,
      max: tier2Max,
    }
  }

  return {
    min: null,
    max: tier1Max,
  }
}
